module.exports = __webpack_public_path__ + "img/Twitter.c2f1acf6.svg";